/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * DS206: Consider reworking classes to avoid initClass
 * DS207: Consider shorter variations of null checks
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/main/docs/suggestions.md
 */
class Composition {
  static initClass() {
    this.ADDED = {};
    this.INITIALIZED_PAGES ={};
  }

  constructor(name, configuration) {
    this.name = name;
    this.configuration = configuration;
    Object.assign(this, configuration);
  }

  runCallbacks(callback) {
    if ((this[callback] != null ? this[callback].length : undefined) > 0) {
      return this[callback].forEach(callback => this[callback](), this);
    }
  }

  run(options) {
    if (options == null) { options = {}; }
    if (this.ran != null) { return this; }
    Object.assign(this, options);
    this.runCallbacks('beforeStart');
    this.start();
    this.runCallbacks('afterStart');
    this.ran = true;
    return this;
  }

  static compose(name, configurationProc) {
    return Composition.ADDED[name] = configurationProc;
  }

  static get(name) {
    return new Composition(name, Composition.ADDED[name]());
  }

  static getPage(name) {
    if (!Composition.INITIALIZED_PAGES) { Composition.INITIALIZED_PAGES = {}; }
    return Composition.INITIALIZED_PAGES[name] || (Composition.INITIALIZED_PAGES[name] = Composition.get(name));
  }
}
Composition.initClass();

export default Composition;
